import { isUndefined as r, isNull as n } from "lodash";
function e({
  tooltipIconProps: i,
  labelInfo: t
}) {
  let o = i;
  return !(r(t) || n(t)) && !o && (o = {
    title: t,
    tooltipProps: {
      isActive: !!t.toString().length
    }
  }), o;
}
export {
  e as tooltipIconPropsConvertor
};
//# sourceMappingURL=index.es5536.js.map
